// Services
import { apiServices } from "@core/services/appService";

// @utility
import { buildGroupedLotteriesDynamic } from "@utility/app/lotteryMatch";

// Redux
import { setStatusSpinner } from "@core/redux/actions/app/spinner";

const SET_LOTTERY_LIST = "app/lottery/SET_LOTTERY_LIST";

function loadLotteryList(lottery_code = "all", setLottertList) {
    return dispatch => {
        apiServices({}, "get", `/general/lottery/list-cache/${lottery_code}/${process.env.REACT_APP_DEFAULT_AGENT_CODE}`).then((data) => {
            const { code: statusCode, result } = data;
            dispatch(setStatusSpinner({ status: false, textProcess: null }));

            if (statusCode === 200 || statusCode === 0) {

                // 🔧 จัดกลุ่มก่อนเซ็ตค่า
                const grouped = buildGroupedLotteriesDynamic(result);

                if (setLottertList) {
                    setLottertList(grouped);
                }
                else {
                    dispatch({
                        type: SET_LOTTERY_LIST,
                        payload: {
                            items: grouped
                        }
                    });
                }
            }
            else {
                if (setLottertList) {
                    setLottertList(null);
                }
                else {
                    dispatch({
                        type: SET_LOTTERY_LIST,
                        payload: {
                            items: null
                        }
                    });
                }
            }
        });
    }
}

export {
    SET_LOTTERY_LIST,
    loadLotteryList
}